"use client";

import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import gaf_certified_plus from "../assets/images/certifications/gaf-certified-plus.png";
import gaf_solar_roof from "../assets/images/certifications/gaf-solar-roof.png";
import gaf_energy from "../assets/images/certifications/gaf-energy.png";
import master_shingle_applicator from "../assets/images/certifications/master-shingle-applicator.png";
import shingle_quality_specialist from "../assets/images/certifications/shingle-quality-specialist.png";
import roofing_contractor from "../assets/images/certifications/roofing-contractor.png";
import fortified_roof_installer from "../assets/images/certifications/fortified-roof-installer.png";
import trp_installer from "../assets/images/certifications/trp-installer.png";

export default function Example() {
  const images = [
    {
      src: gaf_certified_plus,
      alt: "GAF Certified Plus",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain lg:col-span-1 cert-logo",
    },
    {
      src: gaf_solar_roof,
      alt: "GAF Solar Roof",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain lg:col-span-1 cert-logo",
    },
    {
      src: gaf_energy,
      alt: "GAF Energy",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain lg:col-span-1 cert-logo",
    },
    {
      src: master_shingle_applicator,
      alt: "Master Shingle Applicator",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain sm:col-start-2 lg:col-span-1 cert-logo",
    },
    {
      src: shingle_quality_specialist,
      alt: "Shingle Quality Specialist",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain lg:col-span-1 cert-logo",
    },
    {
      src: roofing_contractor,
      alt: "Roofing Contractor",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain lg:col-span-1 cert-logo",
    },
    {
      src: fortified_roof_installer,
      alt: "Fortified Roof Installer",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain lg:col-span-1 cert-logo",
    },
    {
      src: trp_installer,
      alt: "TRP Installer",
      width: 316,
      height: 96,
      className:
        "col-span-2 max-h-24 w-full object-contain lg:col-span-1 cert-logo",
    },
  ];

  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // subtitle and title
      sr.reveal("#certs p", {
        origin: "bottom",
        distance: "20px",
        duration: 600,
        interval: 150,
      });

      // stagger in each logo
      sr.reveal("#certs .cert-logo", {
        origin: "scale",
        scale: 0.85,
        duration: 700,
        interval: 100,
        delay: 300,
      });
    }
  }, []);

  return (
    <div id="certs" className="relative isolate -z-10 my-16 sm:my-12">
      <div className="absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2 justify-center overflow-hidden [mask-image:radial-gradient(50%_45%_at_50%_55%,white,transparent)]">
        <svg
          aria-hidden="true"
          className="h-[40rem] w-[80rem] flex-none stroke-gray-200"
        >
          <defs>
            <pattern
              x="50%"
              y="50%"
              id="e9033f3e-f665-41a6-84ef-756f6778e6fe"
              width={200}
              height={200}
              patternUnits="userSpaceOnUse"
              patternTransform="translate(-100 0)"
            >
              <path d="M.5 200V.5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y="50%" className="overflow-visible fill-gray-50">
            <path
              d="M-300 0h201v201h-201Z M300 200h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect
            fill="url(#e9033f3e-f665-41a6-84ef-756f6778e6fe)"
            width="100%"
            height="100%"
            strokeWidth={0}
          />
        </svg>
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <p className="text-center font-united_sans_sm text-base/7 font-semibold text-[#D2B48C]">
          EXPERTLY TRAINED AND CERTIFIED
        </p>
        <h2 className="text-center font-united_sans_lg mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          OUR CERTIFICATIONS
        </h2>
        <div className="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              width={img.width}
              height={img.height}
              className={img.className}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
